<template>
  <div>
    <h1>EXSBInvoicePosition List</h1>

    <div
      v-if="isLoading"
      class="alert alert-info">Loading...</div>
    <div
      v-if="deletedItem"
      class="alert alert-success">{{ deletedItem['@id'] }} deleted.</div>
    <div
      v-if="error"
      class="alert alert-danger">{{ error }}</div>

    <span v-if="view">
      <pagination
        :view="view"
        @getPage="getPage($event)"
      ></pagination>
    </span>

    <div class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Id</th>
            <th>createdAt</th>
            <th>updatedAt</th>
            <th>deletedAt</th>
            <th>createdBy</th>
            <th>updatedBy</th>
            <th>deletedBy</th>
            <th>state</th>
            <th>invoice</th>
            <th>item</th>
            <th>customItem</th>
            <th>measure</th>
            <th>quantity</th>
            <th>priceNettoPerUnit</th>
            <th>priceNetto</th>
            <th>vatRate</th>
            <th>vatAmount</th>
            <th>priceBrutto</th>
            <th colspan="2" />
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in items"
            :key="item['@id']">
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['@id'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['createdAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['updatedAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['deletedAt'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['createdBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['updatedBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['deletedBy'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['state'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['invoice'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['item'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['customItem'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['measure'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['quantity'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['priceNettoPerUnit'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['priceNetto'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['vatRate'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['vatAmount'] }}
              </router-link>
            </td>
            <td>
              <router-link
                v-if="item"
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                {{ item['priceBrutto'] }}
              </router-link>
            </td>
            <td>
              <router-link
                :to="{name: 'EXSBInvoicePositionShow', params: { id: item['@id'] }}">
                <span
                  class="fa fa-search"
                  aria-hidden="true" />
                <span class="sr-only">Show</span>
              </router-link>
            </td>
            <td>
              <router-link :to="{name: 'EXSBInvoicePositionUpdate', params: { id: item['@id'] }}">
                <span
                  class="fa fa-pencil"
                  aria-hidden="true" />
                <span class="sr-only">Edit</span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      :to="{ name: 'EXSBInvoicePositionCreate' }"
      class="btn btn-primary">Create</router-link>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '../../../Layout/Pagination'

export default {
  components: {
    Pagination
  },
  computed: mapGetters({
    deletedItem: 'exsbinvoiceposition/del/deleted',
    error: 'exsbinvoiceposition/list/error',
    items: 'exsbinvoiceposition/list/items',
    isLoading: 'exsbinvoiceposition/list/isLoading',
    view: 'exsbinvoiceposition/list/view'
  }),

  created () {
    this.getPage()
  },

  methods: mapActions({
    getPage: 'exsbinvoiceposition/list/default'
  })
}
</script>
